<template>
  <el-form ref="form" :model="info" :rules="formRules" label-position="top">
    <h1>Your Info</h1>

    <el-form-item label="Your Name" prop="name">
      <el-input
          :value="info.name"
          @input="storeInfo('name', arguments[0])"
          :rules="[{ required: true, trigger: 'change' }]"
          autofocus />
    </el-form-item>

    <el-form-item label="Email Address" prop="email">
      <el-input
          :value="info.email"
          @input="storeInfo('email', arguments[0])" />
    </el-form-item>

    <el-form-item label="Phone Number" prop="phone">
      <el-input
          :value="info.phone"
          @input="storeInfo('phone', arguments[0])" />
    </el-form-item>

    <el-form-item label="Contact Preference" prop="preferred">
      <el-radio
          :value="info.preferred"
          @input="storeInfo('preferred', arguments[0])"
          label="Email">Email</el-radio>
      <el-radio
          :value="info.preferred"
          @input="storeInfo('preferred', arguments[0])"
          label="Phone">Phone</el-radio>
    </el-form-item>

    <p>&nbsp;</p>

    <ui-form-actions>
      <el-button type="primary" @click="goForward">Continue</el-button>
    </ui-form-actions>
  </el-form>
</template>

<script>
  import step from '../mixins/step';
  import validation from '../mixins/validation';

  export default {
    mixins: [step, validation],
    name: 'Info',
    data() {
      return {
        formRules: {
          name: [
            { required: true, message: 'Please enter your name', trigger: 'change' },
          ],
          email: [
            { type: 'email', required: true, message: 'Please enter your email address', trigger: 'change' },
          ],
          phone: [
            { required: true, message: 'Please enter your phone', trigger: 'change' },
          ],
          preferred: [
            { required: true, message: 'Please choose your contact preference', trigger: 'click' },
          ],
        },
      };
    },
    methods: {
      goForward() {
        this.validate().then(() => {
          this.$router.push({ path: '/gifts' });
        }).catch(() => {
        });
      },
      storeInfo(key, value) {
        this.$store.commit('setInfo', { key, value });
      },
    },
    computed: {
      info() {
        return this.$store.state.info;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/Info.vue